import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../color/color-hsl';
import '../interactions/interactions';
import '../typography/typography';
import ControlDrag from './control-drag';
import css from './control-drag-handle.css';

const ControlDragHandle = ({
  disabled,
  horizontal,
  inverse,
  ...otherProps
}) => (
  <div
    className={classnames(css['ds-control-drag-handle'], {
      [css['ds-control-drag-handle--inverse']]: inverse,
      [css['ds-control-drag-handle--horizontal']]: horizontal,
      [css['ds-control-drag-handle--disabled']]: disabled,
    })}
  >
    <span className={classnames(css['ds-control-drag-handle__thumb'])}>
      <ControlDrag
        inverse={inverse}
        disabled={disabled}
        horizontal={horizontal}
        {...otherProps}
      />
    </span>
  </div>
);

ControlDragHandle.defaultProps = {
  disabled: false,
  horizontal: false,
  inverse: false,
};

ControlDragHandle.propTypes = {
  disabled: PropTypes.bool,
  horizontal: PropTypes.bool,
  inverse: PropTypes.bool,
};

export default ControlDragHandle;
